import React from 'react';
import useField, { useFieldProps } from 'src/hooks/form/useField';
import SEQuotePanel from './SEQuotesComponents/SEQuotePanel';

/**
 * Hook for a single RFQ_QUOTE field (one vendor type) in the Quote Selection task (SMT71).
 * Decorates the field with a per-vendor quote panel; the task-level tab layout + combined footer are
 * provided by SEQuoteTaskTabs. Mandatoriness of a selection is enforced by the backend completion
 * handler (only SMT70-included vendor types), so no static required rule here.
 */
const useSEQuotes = <T>(props: useFieldProps<T>) => {
  const field = useField({ ...props });

  const decorator = (child: React.ReactElement): React.ReactNode => {
    // Pass THIS node's own field model (not whatever was threaded through child.props by the parent
    // render). On the SMT71 task the non-quote fields are never rendered, so the field-group's
    // "all refs populated" re-render never fires — without this, the panel would keep an undefined
    // field and never fetch quotes.
    return field.decorator(
      React.createElement(SEQuotePanel, { ...child.props, field }),
    );
  };

  return {
    ...field,
    decorator,
  };
};

export default useSEQuotes;
